<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-whistle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.266 2.164l-1.993-.175-.116-.003-.114.01a1 1 0 00-.853.902l-.349 3.985-.003.117a1 1 0 00.912.966l1.993.175.117.003a1 1 0 00.966-.912l.349-3.985.003-.117a1 1 0 00-.912-.966zm24.421 10.385L38.02 3.39a2 2 0 00-2.634-.546L11.313 17.049c-.083.05-.163.105-.238.167C5.737 19.513 2 24.82 2 31c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-1.463-.21-2.877-.6-4.214l13-11.566a2 2 0 00.287-2.67zM6 31c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11S6 37.075 6 31zm11-6a6 6 0 110 12 6 6 0 010-12zm-2 6a2 2 0 114 0 2 2 0 01-4 0zM35.854 7.21l-15.523 9.161a15.02 15.02 0 019.34 6.599l10.715-9.533-4.532-6.226zM8.392 12.534l-3.429-2.06a1 1 0 00-1.372.342l-1.03 1.715a1 1 0 00.342 1.372l3.429 2.06a1 1 0 001.372-.342l1.03-1.715a1 1 0 00-.342-1.372zm3.148-8.31l2.237 3.317a1 1 0 01-.27 1.388l-1.659 1.118a1 1 0 01-1.388-.27L8.224 6.46a1 1 0 01.27-1.388l1.658-1.118a1 1 0 011.388.27z"/></svg>
</template>
<script>

export default {
  name: 'IconWhistle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
